import request from '@/utils/request'

export function bindBankCard(form) {
	return request.post('/cust/bindcard', form);
}

// /pay/getcardbin?cardNumber=xxxx
export function getBankCardBin(cardNumber) {
	return request.post('/pay/getcardbin', {cardNumber:cardNumber});
}
